import { render, staticRenderFns } from "./FixedTop.vue?vue&type=template&id=7086065c&scoped=true&"
import script from "./FixedTop.vue?vue&type=script&lang=js&"
export * from "./FixedTop.vue?vue&type=script&lang=js&"
import style0 from "./FixedTop.vue?vue&type=style&index=0&id=7086065c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7086065c",
  null
  
)

export default component.exports